import React from 'react';
import {
    View,
    StyleSheet
} from 'react-native';
import { pt } from '../../common/utils';

import {
    JDImage,
    JDTouchable,
    JDJumping
} from '@jdreact/jdreact-core-lib';

const HotTopBook = ({
    scheduledBannerUrl = '',
    scheduledBannerDetailUrl = ''
}) => {
    if (!scheduledBannerUrl) return <View />;

    const onPress = () => {
        if (scheduledBannerDetailUrl) {
            JDJumping.jumpToWeb(scheduledBannerDetailUrl);
        }
    };

    return (
        <JDTouchable
            onPress={ onPress }
        >
            <JDImage
                style={ styles.img }
                source={ { uri: scheduledBannerUrl } }
            />
        </JDTouchable>
    );
};

export default HotTopBook;

const styles = StyleSheet.create({
    img: {
        width: '100%',
        height: pt(90)
    }
});
